import React from 'react'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from "@mui/material/Tooltip";

function TrackSidebarModuleDropdown(props) {
  const sectionCountLabel = (count) => {
    if (props.language === "chinese") return `${count} 节`;
    if (props.language === "spanish") return `${count} ${count === 1 ? "sección" : "secciones"}`;
    return `${count} ${count === 1 ? "section" : "sections"}`;
  };

  const [showSectionsDropdown, setShowSectionsDropdown] = React.useState(false)

  function toggleShowSectionsDropdown() {
    setShowSectionsDropdown(prevState => !prevState)
  }

  React.useEffect(() => {
    if (props.selectedModuleIndex === props.index) {
      setShowSectionsDropdown(true)
    }
  }, [props.index, props.selectedModuleIndex, props.selectedSectionIndex])

  const moduleTotalSections =
    props.module.annotated_enrollment?.total_sections_count || 0;
  const moduleProgress = moduleTotalSections
    ? ((props.module.annotated_enrollment?.sections_completed_count || 0) /
        moduleTotalSections) *
      100
    : 0;


  return (
    <div>
      <div
        className="pl-2 pr-3 py-4 border-b border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-between cursor-pointer relative"
        onClick={() => {
          toggleShowSectionsDropdown()
          // props.setSelectedModuleIndex(props.index)
          // props.setSelectedSectionIndex(null)
        }}
      >
        {props.selectedModuleIndex === props.index &&
          <div className="h-full w-1 bg-violet-700 absolute left-0"></div>
        }
        <div className="flex-1 min-w-0 flex items-center space-x-1.5">
          <div className="text-xxs text-slate-600 shrink-0">
            {showSectionsDropdown ? <ExpandMoreIcon style={{ fontSize: "20px" }} /> : <ChevronRightIcon style={{ fontSize: "20px" }} />}
          </div>
          <div className="min-w-0">
            <Tooltip title={props.module.name || ""} placement="right" arrow>
              <p className="text-slate-900 text-sm font-semibold truncate">{props.module.name}</p>
            </Tooltip>
            <p className="text-slate-500 text-xs">{sectionCountLabel(props.module.sections.length)}</p>
          </div>
        </div>
        <div className="relative w-6 h-6 ml-3 shrink-0">
          {/* Progress ring using conic-gradient */}
          {props.type !== "Preview" && moduleProgress < 100 && (
            <div
              className="absolute inset-0 rounded-full"
              style={{
                background: `conic-gradient(
                  #059669 ${moduleProgress * 3.6}deg,
                  #e2e8f0 ${moduleProgress * 3.6}deg
                )`
              }}
            />
          )}

          {/* Center circle with checkmark */}
          <div
            className={`absolute inset-0 m-auto w-5 h-5 rounded-full flex items-center justify-center ${
              moduleProgress === 100 ? "bg-emerald-600" : "bg-white"
            }`}
          >
            {moduleProgress === 100 && (
              <CheckIcon className="text-white" style={{ fontSize: "18px" }} />
            )}
          </div>
        </div>
      </div>
      {showSectionsDropdown &&
        <div>
          {props.module.sections.map((section, index) => (
            <div
              key={index}
              className={`pl-8 pr-4 py-4 border-b border-slate-200 bg-slate-50 ${props.userType === "Manager" || (props.userType === "Employee" && index <= props.nextSectionIndex && props.index <= props.nextModuleIndex) || section?.annotated_enrollment?.is_completed ? "hover:bg-slate-100 cursor-pointer" : ""} flex items-center justify-between gap-x-3 ${
                props.selectedSectionIndex === index && props.selectedModuleIndex === props.index ? 'bg-slate-200' : ''
              }`}
              onClick={
                !props.isLoading && (props.userType === "Manager" || (props.userType === "Employee" && index <= props.nextSectionIndex && props.index <= props.nextModuleIndex) || section?.annotated_enrollment?.is_completed)
                  ? () => {
                      if (props.onSelectSection) {
                        props.onSelectSection(props.index, index, section);
                        return;
                      }
                      props.removeAllBlocks();
                      props.setSelectedModuleIndex(props.index);
                      props.setSelectedSectionIndex(index);
                      props.fetchSectionDetail(true, section.uuid, props.selectedEmployee ? props.selectedEmployee?.id : null);
                      props.setSelectedSectionUUID(section.uuid);
                      if (props.setIsCurrentSectionCompleted) {
                        props.setIsCurrentSectionCompleted(section.annotated_enrollment?.is_completed);
                      }
                    }
                  : null
              }
            >
              <div className="flex-1 min-w-0 flex items-center space-x-2">
                <p className="text-slate-500 text-xs shrink-0 tabular-nums">{index + 1}.</p>
                <Tooltip title={section.name || ""} placement="right" arrow>
                  <div className="flex-1 min-w-0">
                    <p className="text-slate-800 text-xs truncate">{section.name}</p>
                    {section.annotated_enrollment?.is_tested_out && (
                      <p className="text-slate-500 text-xxs">
                        {props.language === "chinese"
                          ? "已通过测试跳过"
                          : props.language === "spanish"
                            ? "Omitida por examen"
                            : "Tested out"}
                      </p>
                    )}
                  </div>
                </Tooltip>
              </div>
              <div className="shrink-0">
                {props.selectedSectionIndex === index && props.selectedModuleIndex === props.index ?
                section.annotated_enrollment?.is_completed ?
                  <div className="w-4 h-4 rounded-full border bg-emerald-600 border-emerald-600 text-white flex items-center justify-center">
                    <CheckIcon style={{ fontSize: "14px" }} />
                  </div> :
                  <div className="w-4 h-4 rounded-full border bg-slate-200 border-violet-700 flex items-center justify-center">
                    <div className="w-2 h-2 rounded-full bg-violet-700"></div>
                  </div> :
                section.annotated_enrollment?.is_completed ?
                  <div className="w-4 h-4 rounded-full border bg-emerald-600 border-emerald-600 text-white flex items-center justify-center">
                    <CheckIcon style={{ fontSize: "14px" }} />
                  </div> :
                  <div className="w-4 h-4 rounded-full border bg-white border-slate-300"></div>
                }
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  )
}

export default TrackSidebarModuleDropdown
